'use client'

import React from 'react'

type SilentBoundaryProps = {
  children: React.ReactNode
  // Names the subtree in the console so a swallowed crash can still be attributed.
  name: string
}

// Error boundary for headless syncs and overlay hosts that render outside any widget boundary.
// Without it, one of them throwing unmounts the whole route; with it, only that subtree goes
// quiet (renders nothing) and the error is logged. It does not retry: a remount of the parent
// (e.g. navigating) starts it fresh.
export class SilentBoundary extends React.Component<SilentBoundaryProps, { hasError: boolean }> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error(`[SilentBoundary:${this.props.name}]`, error, info.componentStack)
  }

  render() {
    return this.state.hasError ? null : this.props.children
  }
}
